export const certification = [
    {
        nombre: "React JS",
        lugar: "Coderhouse",
        IDCredencial: "6205d285a77a91004af64026"
    },
    {
        nombre: "Curso de Asincronismo con JavaScript",
        lugar: "Platzi",
        IDCredencial: "36976835-e24f-4906-bf68-092cb276650c"
    },
    {
        nombre: "Curso de ECMAScript 6",
        lugar: "Platzi",
        IDCredencial: "332aeed3-8cd4-4356-9bc2-392fc9494370"
    },
    {
        nombre: "Curso de Frontend Developer",
        lugar: "Platzi",
        IDCredencial: "a3cecb7a-77bc-4bb5-9e74-5e4adf3192a7"
    },
    {
        nombre: "NodeJS desde 0",
        lugar: "KODOTI",
    },
    {
        nombre: "Scrum Foundation",
        lugar: "CertiProf",
        IDCredencial: "FLCBQWDSDJ-SSKDGDGF WHKHNWBDN"
    },
    {
        nombre: "Fundamentos Git y Github",
        lugar: "DevCode.la",
        IDCredencial: "5V6K1P0G2F"
    },
    {
        nombre: "Introduccion al Desarrollo Web II",
        lugar: "Google Actívate",
        IDCredencial: "8XJVW6EYJ"
    },
    {
        nombre: "Pug desde ceroPug desde cero",
        lugar: "EDteam",
    },
    {
        nombre: "Kanban Comprendelo Facilmenteo",
        lugar: "Udemy",
    },
    {
        nombre: "Google Analytics for Beginners",
        lugar: "Google Actívate",
    },
    {
        nombre: "TOEIC Bridge",
        lugar: "ETS",
    },
]

